/**
 * 商品 属性 断面宽，尺寸，花纹，是否是支持快递
 */
export enum ProductAttributeEnums {
  SELECT_WIDTH = "_sectionWidth",
  HUB_DIAMETER = "_hubDiameter",
  FLATTEN = "_flatten",
  PATTERN = "_pattern",
  IS_EXPRESS = "isExpress",
  SPECIFICATION = "_specification"
}

/**
 * 订单状态
 * WAIT_PAY("21", "Waiting for payment", "等待付款", "Waiting for payment"),
   PAID("22", "Paid", "已付款", "Paid"),
   WAIT_SEND("31", "Waiting for shipment（Waiting）", "等待發貨", "Waiting for shipment"),
   IN_PROCESSING("41", "Processed", "處理中", "In processing"),
   WAIT_RECEIVE("42", "Waiting for receiving（Accepted）", "等待收貨", "Waiting for receiving"),
   COMPLETE("51", "Completed", "已完成", "Completed"),
   USER_CANCELED("61", "Canceled", "已取消", "Cancelled"),
   SYS_CANCELED("62", "Canceled", "自動取消", "Auto Cancelled"),
   COMMENTED("91", "Commented", "评论", "commented");
 */
export enum MallOrderStatusEnums {
  WAIT_PAY = "21",
  PAID = "22",
  WAIT_SEND = "31",
  IN_PROCESSING = "41",
  WAIT_RECEIVE = "42",
  COMPLETE = "51",
  USER_CANCELED = "61",
  SYS_CANCELED = "62",
  COMMENTED = "91",
  CANCELING = "_"
}

/**
 * 订单状态对应的文案
 */
export const MallOrderStatusNameJson = Object.freeze({
  [MallOrderStatusEnums.WAIT_PAY]: "待支付",
  [MallOrderStatusEnums.PAID]: "已支付",
  [MallOrderStatusEnums.WAIT_SEND]: "待发货",
  [MallOrderStatusEnums.WAIT_RECEIVE]: "待收货",
  [MallOrderStatusEnums.IN_PROCESSING]: "待收货", // 处理中
  [MallOrderStatusEnums.COMPLETE]: "已完成",
  [MallOrderStatusEnums.USER_CANCELED]: "已取消",
  [MallOrderStatusEnums.SYS_CANCELED]: "已取消",
  [MallOrderStatusEnums.COMMENTED]: "已评论",
  [MallOrderStatusEnums.CANCELING]: "取消中"
});

/**
 * 11： 快递订单，  21： 普通订单
 */
export enum MallOrderExpressStatusEnums {
  EXPRESS = "11",
  NORMAL = "21"
}

/**
 * 我的优惠券，1 未使用，2 已使用， 3 已过期
 */
export enum CouponTypeEnums {
  USEABLE = "1",
  USED = "2",
  EXPIRED = "3"
}

export const ONLINE_PAYMENT_TEXT = "线上支付";
export const OFFLINE_PAYMENT_TEXT = "线下支付";
export const GOTO_SUCCEED_FLAG = "1"; // 跳转成功开关

export const PaymentTextMap = Object.freeze({
  online: ONLINE_PAYMENT_TEXT,
  offline: OFFLINE_PAYMENT_TEXT
});

/**
 * 支付方式
 */
export enum PaymentMethodEnums {
  ALI_PAY = "alipaynative",
  WX_PAY = "weixinapplet",
  CLOUD_PAY = "unionpayApp",
  BOUNTY_PAY = "walletpay",
  OFFLINE = "offline",
  ONLINE = "online"
}

export const PaymentMethodNameMap = Object.freeze({
  [PaymentMethodEnums.ALI_PAY]: "支付宝支付",
  [PaymentMethodEnums.WX_PAY]: "微信支付",
  [PaymentMethodEnums.CLOUD_PAY]: "云闪付",
  [PaymentMethodEnums.BOUNTY_PAY]: "奖励金支付",
  [PaymentMethodEnums.OFFLINE]: OFFLINE_PAYMENT_TEXT,
  [OFFLINE_PAYMENT_TEXT]: OFFLINE_PAYMENT_TEXT
});

// 下单后参与的活动类型
export enum OrderActivityTypeEnums {
  COUPON = "2", // 优惠券
  DRAW = "4" // 抽奖券
}

// 订单物流类型，0非快递，1快递
export enum OrderExpressTypeEnums {
  NO_EXPRESS = 0,
  EXPRESS = 1
}

// 优惠券类型，01：元, 03: 折扣
export enum UnitTypeEnums {
  YUAN = "01",
  DISCOUNT = "03"
}
